(function () {
  'use strict';

  function init(root) {
    var cards = root.querySelectorAll('.merch-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var media = card.querySelector('.merch-media');
      var images = card.querySelectorAll('.merch-img');
      var pending = images.length;

      function settle() {
        pending -= 1;
        if (pending <= 0 && media) media.classList.add('is-loaded');
      }

      images.forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
          settle();
        } else {
          img.addEventListener(
            'load',
            function () {
              this.classList.add('is-loaded');
              settle();
            },
            { once: true }
          );
          img.addEventListener('error', settle, { once: true });
        }
      });

      // Touch: press and hold shows the second image instead of firing the link.
      // A normal tap still navigates to the product page.
      var holdTimer = null;
      var peeked = false;

      card.addEventListener(
        'touchstart',
        function () {
          peeked = false;
          holdTimer = setTimeout(function () {
            peeked = true;
            card.classList.add('is-peeking');
          }, 220);
        },
        { passive: true }
      );

      function release(e) {
        clearTimeout(holdTimer);
        if (peeked) {
          if (e.cancelable) e.preventDefault();
          card.classList.remove('is-peeking');
          peeked = false;
        }
      }

      card.addEventListener('touchend', release);
      card.addEventListener('touchcancel', release);
    });
  }

  function boot() {
    document.querySelectorAll('.merch-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var wrapper = e.target.querySelector('.merch-wrapper');
    if (wrapper) init(wrapper);
  });
})();